import { observer } from 'mobx-react-lite';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import { AnimatedCircleChart } from '../../../elements/Chart/AnimatedCircleChart';
import { Container } from './Styles';

import { createBrowserHistory } from 'history';
const StyledSVGCircle = ({
  auctionID = '',
  auctionName,
  bgcolor = '',
  chartError = 0,
  clickRoute = null,
  id,
  laneID = '',
  laneName,
  percentvalue = 0,
  popupContent = null,
  popupHeader = null,
  popupPosition = 'top center',
  showPercentsign = true,
  size = 120,
  testId,
  text = 'label here',
}) => {
  const history = createBrowserHistory({ forceRefresh: true });
  const handleClick = () => {
    const state = { auctionName, laneName };

    let url = '';
    if (laneID !== '') {
      url = `/auction/${auctionID}/lane/${laneID}/productImages/`;
      //history.push(url)
    } else {
      if (auctionID !== '') {
        url = `/auction/${auctionID}/productImages/`;
      }
    }

    url = clickRoute;
    history.push(url, state);
  };

  const getPopupContent = (lane, auction, rangeText, percent) => {
    const auctionOrLaneImageUpload = lane
      ? `${lane} lane`
      : `${auction} auction`;
    const formattedTotalCompleted = rangeText.replace('/', ' out of ');
    const status = `${percent}% complete`;
    return `The ${auctionOrLaneImageUpload} is ${status} with a total of ${formattedTotalCompleted} images uploaded. You may click the circle to view all these images.`;
  };

  return (
    <Container data-testid={`${testId}-container`}>
      <Popup
        content={
          popupContent ||
          getPopupContent(laneName, auctionName, text, percentvalue)
        }
        data-testid={`${testId}-popup`}
        header={popupHeader}
        key={`dash_circle_popup_${id}`}
        position={popupPosition}
        size="tiny"
        trigger={
          <div>
            <AnimatedCircleChart
              onClick={() => handleClick()}
              value={percentvalue}
              topText={`${percentvalue}%`}
              bottomText={text}
              bgColor={bgcolor}
              error={chartError}
            />
          </div>
        }
      />
    </Container>
  );
};

export default observer(StyledSVGCircle);
